<template>
  <div>
    <div class="verify_result" v-if="loading">
      <div class="head">
        <h2>防伪验证</h2>
        <span class="el-icon-arrow-left" @click="handleBack"></span>
      </div>
      <div class="success" v-if="showSuccess">
        <div class="top">
          <img
            src="../assets/img/verify/yanzheng1.png"
            alt
            class="img_top"
            v-if="showFirst"
          />
          <div class="warn" v-if="showReuse">
            <img src="../assets/img/verify/zhengpin1.png" alt />
            <div class="warn_text">
              <p>您已于2020年02月02日 验证绑定成功</p>
              <span>点击证书预览完整内容，或保证证书留存维修信息</span>
            </div>
          </div>
        </div>
        <div class="hint">
          <img src="../assets/img/verify/tongzhi1.png" alt />
          <p>长按防伪证书保存到本地</p>
        </div>
        <div class="center">
          <img :src="imgUrl" alt />
        </div>
      </div>
      <div class="fail" v-if="showFailed">
        <div class="failed">
          <img src="../assets/img/verify/failed1.png" alt />
        </div>
        <div class="info">
          <h3>注意事项 :</h3>
          <p>1、每个乐器二维码是唯一标识；</p>
          <p>2、扫描后需绑定维修信息，才可以查询防伪证书；</p>
          <p>3、绑定成功后会赠送相关课程；</p>
          <p>4、重复扫描验证不会再赠送课程。</p>
        </div>
      </div>
      <img src="../assets/img/verify/logo1.png" alt class="logo" />
      <Download />
    </div>
    <Failed v-if="!loading" />
  </div>
</template>

<script>
import Download from "@/components/download.vue";
import Failed from "@/components/failed.vue";
export default {
  data() {
    return {
      qrCode: "", //二维码
      originCode: "", //来源
      sessionId: "",
      showReuse: false, //重复绑定显示
      boundTime: "", //首次绑定时间
      imgUrl: "", //防伪证书图片
      showSuccess: false, //扫码成功与否
      loading: true,
      showFirst: false,
      showFailed: false,
    };
  },
  mounted() {
    let { code, scan_source } = this.$route.query;
    this.qrCode = code;
    this.originCode = scan_source;
    // this.sessionId = localStorage.session_id;
    this.getProve();
  },
  methods: {
    getProve() {
      this.$API
        .getCertificate({
          code: this.qrCode,
          scan_source: this.originCode,
          type: "musicdevicecodeverify",
        })
        .then((res) => {
          // console.log(res);
          if (res.error_code == 0) {
            if (res.data.binding_status == 2) {
              this.showSuccess = true;
              this.showReuse = true;
              this.imgUrl = res.data.certificate_img;
              this.boundTime = res.data.scan_time;
            } else if (res.data.binding_status == 0) {
              this.showSuccess = false;
              this.showFailed = true;
            } else if (res.data.binding_status == 1) {
              this.showSuccess = true;
              this.showFirst = true;
              this.imgUrl = res.data.certificate_img;
            }
          } else if (res.error_code == 16001003) {
            this.loading = false;
          } else {
            this.$router.replace("/");
          }
        });
    },

    handleBack() {
      this.$router.go(-1);
    },
  },
  components: {
    Download,
    Failed,
  },
};
</script>

<style scoped lang="scss">
.verify_result {
  font-family: "PingFang SC";
  padding-bottom: 72px;
  height: 100%;
  .head {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    position: relative;
    h2 {
      font-size: 16px;
      font-weight: 500;
      color: #333436;
      letter-spacing: 0px;
    }
    span {
      position: absolute;
      top: 9px;
      left: 17px;
      font-size: 22px;
      font-weight: 550;
    }
  }
  .success {
    .top {
      width: 100%;
      .warn {
        background-color: #fe9424;
        width: 100%;
        height: 85px;
        display: flex;
        align-items: center;
        img {
          margin-left: 13px;
          width: 36px;
          height: 36px;
          object-fit: cover;
        }
        &_text {
          height: 40px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 15px;
          text-align: left;
          color: #ffffff;
          p {
            font-size: 15px;
            font-weight: 500;
          }
          span {
            font-size: 13px;
          }
        }
      }
    }
    .hint {
      width: 343px;
      margin: 16px auto;
      height: 37px;
      background: #fff7e1;
      border-radius: 8px;
      display: flex;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
        margin-left: 15px;
        object-fit: cover;
      }
      p {
        font-size: 14px;
        text-align: left;
        color: #e2933e;
        margin-left: 12px;
      }
    }
    .center {
      width: 347px;
      height: 439px;
      margin: 20px auto 18px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .fail {
    .failed {
      margin-bottom: 20px;
      img {
        width: 100%;
        height: 75px;
        object-fit: cover;
      }
    }
    .info {
      text-align: left;
      margin: 0 auto;
      width: 326px;
      h3 {
        font-size: 16px;
        font-weight: 600;
        color: #323643;
        margin-bottom: 9px;
      }
      p {
        margin-bottom: 3px;
        font-size: 12px;
        color: #979797;
      }
    }
  }
  .logo {
    width: 111px;
    height: 30px;
    margin: 0 auto;
    margin-top: 36px;
  }
  .verify_shade {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 8;
  }
  .content {
    width: 247px;
    height: 137px;
    background: #ffffff;
    border-radius: 8px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 9;
    h3 {
      font-size: 16px;
      font-weight: 600;
      color: #333338;
      margin-top: 7px;
      margin-bottom: 20px;
    }
    &_text {
      font-size: 16px;
      color: #333338;
      margin-bottom: 25px;
    }
    &_btn {
      height: 42px;
      line-height: 42px;
      border-top: 1px solid #ededed;
      font-size: 14px;
      color: #07d1aa;
    }
  }
}

img {
  vertical-align: bottom;
}
</style>